import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay, switchMap, tap } from 'rxjs/operators';

import { APIService, KPI } from '../api';

@Injectable()
export class InitiativeTagsService {

  private _initiativeTags$: Observable<KPI.InitiativeTag[]>;
  private initiativeTagsRefresh$ = new BehaviorSubject<void>(null);

  constructor(
    private api: APIService,
  ) { }

  public get initiativeTags$(): Observable<KPI.InitiativeTag[]> {
    if (!this._initiativeTags$) {
      this._initiativeTags$ = this.initiativeTagsRefresh$.pipe(
        switchMap(() => this.api.get_initiative_tags()),
        shareReplay(1),
      );
    }

    return this._initiativeTags$;
  }

  public refreshInitiativeTags(): void {
    this.initiativeTagsRefresh$.next();
  }

  public createInitiativeTag(
    initiativeTag: Partial<KPI.InitiativeTag>,
  ): Observable<KPI.InitiativeTag> {
    return this.api.initiative_tags_post(initiativeTag).pipe(
      tap(() => this.refreshInitiativeTags()),
    );
  }

  public updateInitiativeTag(
    id: number,
    initiativeTag: Partial<KPI.InitiativeTag>,
  ): Observable<KPI.InitiativeTag> {
    return this.api.initiative_tags_patch(id, initiativeTag).pipe(
      tap(() => this.refreshInitiativeTags()),
    );
  }

  public deleteInitiativeTag(
    initiativeTagId: number,
  ): Observable<KPI.InitiativeTag> {
    return this.api.initiative_tags_delete(initiativeTagId).pipe(
      tap(() => this.refreshInitiativeTags()),
    );
  }

}
